<template>
  <div class="newslist">
      <div class="c_l_title">
          <div class="c_l_title_l"></div>
          <div class="c_l_title_b">
              <div class="t_b_title">
                {{detailInfo.news_title}}
              </div>
              <div class="t_b_list">
                  <div class="t_b_time">发布时间：{{detailInfo.create_time}}</div>
                  <div class="t_b_from">来源：{{detailInfo.create_time}}</div>
                   <div class="t_b_from">来源：{{detailInfo.create_time}}</div>
                    <div class="t_b_from">阅读数：{{detailInfo.read_num}}</div>
              </div>
          </div>
          <div class="c_l_title_r" @click="gotohistory">
              {{c_l_title_r}}
          </div>
      </div>
      <div class="c_l_content">
        <div v-html="detailInfo.news_content"></div>
      </div>
  </div>
</template>

<script>
    import {getNewsDetail} from '../../api/apis.js'
export default {
  name: 'Newslist',
  data() {
      return {
          c_l_title_r:'',
          index:'',
          detailInfo:{}
      }
  },
  methods: {
      //接收参数
      getindex(title,index,id) {

           this.c_l_title_r = title;
           this.index = index;
           getNewsDetail({id:id}).then(res => {
                this.detailInfo = res;
           })

      },
      gotohistory(){
          this.$emit('gotohistory',100);
      }
  },
}
</script>
<style lang="scss" scoped>
.newslist{
    // border:1px solid red;
    width: 1200px;
    .c_l_title{
         border-bottom: 1px dashed #CECECE;
         width: 1200px;
         height: 100px;
         display: flex;
         justify-content: space-between;
         align-items: center;
         .c_l_title_l{
             width: 139px;
             height: 42px;
         }
         .c_l_title_b{
            //  border:1px solid red;
              width: 600px;
                height: 70px;
                display: flex;
                justify-content: space-around;
                align-items: center;
                flex-direction: column;
                .t_b_title{
                    //  border:1px solid red;
                    width:452px;
                    height:31px;
                    font-size:24px;
                    font-family:Microsoft YaHei;
                    font-weight:400;
                    line-height:31px;
                    color:rgba(51,51,51,1);
                    opacity:1;
                }
                .t_b_list{
                    // border:1px solid red;
                     width:700px;
                     color: #999999;
                     display: flex;
                     justify-content: space-between;
                     font-size: 12px;
                }
         }
         .c_l_title_r{
             width:139px;
            height:42px;
            background:rgba(21,132,245,1);
            border-radius:4px;
            font-size:16px;
            font-family:Microsoft YaHei;
            font-weight:400;
            line-height:42px;
            text-align: center;
            color:rgba(255,255,255,1);
            opacity:1;
            cursor: pointer;
         }
    }
    .c_l_content{
        // border:1px solid red;
        width: 100%;
        height: 100%;
        /* margin-top: 80px; */
        padding:80px;

    }
}
</style>